module.exports = __webpack_public_path__ + "08fd05e293b9b2688277d009fa9902b9.png";